import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import { AppState } from '../store/app.state';
import { selectUserRole } from '../store/auth/auth.selectors';
import { shouldUseMobileHub } from '../pwa/pwa-runtime.util';

export const roleGuard: (allowedRoles: string[]) => CanActivateFn = (allowedRoles) => {
  return () => {
    const store = inject(Store<AppState>);
    const router = inject(Router);

    return store.select(selectUserRole).pipe(
      take(1),
      map((role) => {
        if (!role) {
          router.navigate(['/login']);
          return false;
        }

        if (allowedRoles.includes(role)) {
          return true;
        }

        // Redirect based on role
        if (role === 'super_admin') {
          router.navigate(['/admin']);
        } else if (role === 'waiter') {
          router.navigate([shouldUseMobileHub() ? '/mobile/floor-plan/live' : '/floor-plan/live']);
        } else {
          router.navigate(['/dashboard']);
        }

        return false;
      })
    );
  };
};
